module.exports = __webpack_public_path__ + "static/media/stars.f5ad1ef2.png";